import { getDynamicText } from '../services/questionnaire';

const dynamicTextQuery = {
  key: 'dynamicText',
  query: getDynamicText,
};

export { dynamicTextQuery };
